export default __webpack_public_path__ + "static/apace_1-f4cfb34151fb7ea4d98e625310289a39.png";